/** Up to two uppercase letters for the avatar fallback, e.g. "Schenkwerk GmbH" → "SG". */
export function companyInitials(name: string | undefined): string {
  if (!name) return '';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]!.toUpperCase())
    .join('');
}
